export default __webpack_public_path__ + "static/media/mobile_payments.1ddae4f8.png";